import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { getError, getReducer } from '../../../../utils';

import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';
import '../css/register.css';

import AnimatedInput from './AnimatedInput';
import { InputFields } from '../../../../data/layouts/register';
import useInfoFilters from '../../../../data/layouts/useInfo';
import LoadingBox from '../../../compoment/LoadingBox';
import MessageBox from '../../../compoment/MessageBox';
import { Store } from '../../../../Store';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loadingInfo: true };
    case 'FETCH_SUCCESS':
      return { ...state, loadingInfo: false };
    case 'FETCH_FAIL':
      return { ...state, loadingInfo: false, errorInfo: action.payload };
    default:
      return state;
  }
};

const Register = ({ onClose, close, isUserInfo }) => {
  const [{ loadingInfo, errorInfo }, dispatch] = useReducer(
    getReducer(reducer),
    {
      loadingInfo: false,
      errorInfo: '',
    }
  );

  const [formData, setFormData] = useState({
    code: '',
    full_name: '',
    date_of_birth: '',
    gender: '',
    email: '',
    phone_number: '',
    avatar_url: '',
    address: '',
    username: '',
    password: '',
    rePassword: '',
    options: [],
  });
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);

  const fileInputRef = useRef(null);

  const [errors, setErrors] = useState({});
  const [isOpenField, setIsOpenField] = useState(null);

  const { loading, error, filtersRegister, filtersFamily } = useInfoFilters();

  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    const fetchData = async () => {
      if (!isUserInfo || !userInfo || !userInfo.userInformation) return;

      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const { data } = await axios.get('/user/profile', {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });

        setFormData({
          id: data.data.id,
          code: data.data.code,
          full_name: data.data.full_name,
          date_of_birth: data.data.date_of_birth,
          gender: data.data.gender,
          email: data.data.email,
          phone_number: data.data.phone_number,
          avatar_url: data.data.avatar_url,
          address: data.data.address,
          username: data.data.username,
          options: data.data.attributeValues,
        });

        dispatch({ type: 'FETCH_SUCCESS' });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };

    fetchData();
  }, [isUserInfo, userInfo]);

  const handleToggle = (fieldName) =>
    setIsOpenField((prev) => (prev === fieldName ? null : fieldName));

  const validateFormData = (data) => {
    const errors = {};

    if (!data.code.trim()) errors.code = 'Vui lòng nhập mã thành viên.';
    if (!data.full_name.trim()) errors.full_name = 'Vui lòng nhập họ và tên.';
    if (!data.date_of_birth.trim())
      errors.date_of_birth = 'Vui lòng chọn ngày sinh.';
    if (!data.gender.trim()) errors.gender = 'Vui lòng chọn giới tính.';
    if (!data.email.trim()) errors.email = 'Vui lòng nhập email.';
    if (!data.phone_number.trim())
      errors.phone_number = 'Vui lòng nhập số điện thoại.';
    if (!data.address.trim()) errors.address = 'Vui lòng nhập địa chỉ.';
    if (!data.username.trim()) errors.username = 'Vui lòng nhập tên đăng nhập.';

    return errors;
  };

  const handleUpload = async () => {
    const data = new FormData();
    const errors = {};
    files.forEach((file) => data.append('files', file));
    if (files.length === 0) return true;
    const url = `/files/public/avatar`;

    try {
      // Gửi file lên server
      const uploadRes = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (uploadRes?.data?.status !== 200) {
        errors.avatar_url = 'Tải ảnh lên thất bại. Vui lòng thử lại!';
        setErrors(errors);
        return false;
      }

      const uploaded = uploadRes?.data?.data;
      let avatar =
        Array.isArray(uploaded) && uploaded.length > 0
          ? uploaded[uploaded.length - 1]
          : null;

      if (!avatar?.url) {
        errors.avatar_url = 'Không có ảnh nào được tải lên.';
        setErrors(errors);
        return false;
      }

      setFormData((prev) => ({
        ...prev,
        avatar_url: avatar.url,
      }));
      setErrors({});
      return true;
    } catch (error) {
      errors.avatar_url = 'Lỗi khi tải ảnh đại diện.';
      setErrors(errors);
      return false;
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const validationErrors = validateFormData(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Vui lòng kiểm tra lại các trường bị lỗi.');
      return;
    }

    if (files.length > 0) {
      const result = await handleUpload();
      if (!result) return;
    }

    try {
      const { data } = isUserInfo
        ? await axios.put('/user/update-profile', formData, {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          })
        : await axios.post('/member/register', formData);
      toast.success(data.messages || data.message);
      if (isUserInfo) {
        close();
      } else onClose();
    } catch (err) {
      const messages = err.response?.data?.messages;
      if (err.response?.status === 422 && messages) {
        setErrors(messages);
      } else {
        toast.error(getError(err));
      }
    }
  };

  useEffect(() => {
    if (formData.avatar_url && previews.length === 0) {
      setPreviews([{ file: null, url: formData.avatar_url, id: 'existing' }]);
    }
  }, [formData.avatar_url]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (value, field, isOption, id) => {
    const newValue = typeof value === 'string' ? value : value.target.value;
    const newOption = { userAttributeId: id, value: newValue };

    setFormData((prev) => {
      if (isOption) {
        const updatedOptions = prev.options.some(
          (opt) => opt.userAttributeId === id
        )
          ? prev.options.map((opt) =>
              opt.userAttributeId === id ? { ...opt, value: newValue } : opt
            )
          : [...prev.options, newOption];

        return {
          ...prev,
          options: updatedOptions,
        };
      } else {
        return {
          ...prev,
          [field.key || field.name]: newValue,
        };
      }
    });
  };

  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  const PREVIEW_BATCH_SIZE = 5;
  const PREVIEW_DELAY = 100;

  const createThumbnail = useCallback((file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX_WIDTH = 300;
          const MAX_HEIGHT = 200;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height = Math.round((height * MAX_WIDTH) / width);
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width = Math.round((width * MAX_HEIGHT) / height);
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              const thumbnailUrl = URL.createObjectURL(blob);
              resolve(thumbnailUrl);
            },
            file.type,
            0.7
          );
        };
        img.onerror = () => reject(new Error('Failed to load image'));
        img.src = event.target.result;
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
    });
  }, []);

  const createPreviews = async (validFiles) => {
    try {
      const newPreviews = [];

      for (let i = 0; i < validFiles.length; i += PREVIEW_BATCH_SIZE) {
        const batch = validFiles.slice(i, i + PREVIEW_BATCH_SIZE);

        const batchPromises = batch.map(async (file) => {
          try {
            const thumbnailUrl = await createThumbnail(file);
            return {
              file,
              url: thumbnailUrl,
              id: Math.random().toString(36).substring(2, 11),
            };
          } catch (error) {
            return {
              file,
              url: null,
              id: Math.random().toString(36).substring(2, 11),
              error: true,
            };
          }
        });

        const batchObjects = await Promise.all(batchPromises);
        newPreviews.push(...batchObjects);

        setPreviews((prev) => [...prev, ...batchObjects]);
        setFiles((prevFiles) => [...prevFiles, ...batch]);

        if (i + PREVIEW_BATCH_SIZE < validFiles.length) {
          await new Promise((resolve) => setTimeout(resolve, PREVIEW_DELAY));
        }
      }

      return newPreviews;
    } catch (error) {
      toast.error('Có lỗi xảy ra khi tạo xem trước hình ảnh.');
      return [];
    } finally {
    }
  };

  const validateFiles = (fileList) => {
    const validFiles = [];
    const errorMessages = [];

    Array.from(fileList).forEach((file) => {
      if (!ALLOWED_TYPES.includes(file.type)) {
        errorMessages.push(
          `"${file.name}" không phải là định dạng hình ảnh hợp lệ.`
        );
      } else if (file.size > MAX_FILE_SIZE) {
        errorMessages.push(`"${file.name}" vượt quá kích thước tối đa (10MB).`);
      } else {
        validFiles.push(file);
      }
    });

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join('\n'));
    }

    return validFiles;
  };

  const handleFileChange = async (e) => {
    previews.forEach((preview) => {
      if (preview.url) {
        URL.revokeObjectURL(preview.url);
      }
    });

    setFiles([]);
    setPreviews([]);

    const validFiles = validateFiles(e.target.files);

    if (validFiles.length > 0) {
      await createPreviews(validFiles);
    }
  };

  const renderFieldGroup = (title, fields, isOption) => (
    <>
      <h4>{title}</h4>
      <div className="row">
        {fields
          .filter((field) => !(isUserInfo && field.type === 'password'))
          .map((field, idx) => {
            if (isUserInfo && field.type === 'password') return null;

            const optionValue =
              formData.options.find((opt) => opt.userAttributeId === field.id)
                ?.value || '';

            return (
              <div key={idx} className={` col-lg-${field.collum || 6} `}>
                <div className="input-button-row">
                  <div className="input-wrapper">
                    <AnimatedInput
                      field={field}
                      value={
                        isOption
                          ? optionValue
                          : formData[field.key || field.name]
                      }
                      checked={formData[field.key]}
                      onChange={(e) =>
                        handleInputChange(e, field, isOption, field.id)
                      }
                      onSelectOption={(selectedValue) =>
                        handleInputChange(
                          selectedValue,
                          field,
                          isOption,
                          field.id
                        )
                      }
                      isOpen={isOpenField === field.name}
                      onToggle={() => handleToggle(field.name)}
                      error={errors[field.errorKey]}
                    />
                  </div>
                  {field.key === 'avatar_url' && (
                    <div className="button-image">
                      <span
                        className="click-image"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Chọn ảnh
                      </span>

                      <input
                        type="file"
                        ref={fileInputRef}
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden-input"
                      />
                    </div>
                  )}
                </div>

                {field.key === 'avatar_url' &&
                  (previews.length > 0 || formData.avatar_url) && (
                    <div className="mb-4 p-2 prev-image">
                      <p>Xem trước</p>
                      <div className="show-image ">
                        <img
                          src={previews[0]?.url || formData.avatar_url}
                          alt="Xem trước"
                          style={{
                            maxWidth: '100%',
                            height: '200px',
                          }}
                        />
                      </div>
                    </div>
                  )}

                {field.key === 'password' && (
                  <aside className="note-pass">
                    <strong style={{ color: 'var(--red)' }}>Lưu ý: </strong>
                    Mật khẩu phải chứa ít nhất 8 ký tự, chữ hoa, chữ thường và
                    số.
                  </aside>
                )}
              </div>
            );
          })}
      </div>
    </>
  );

  return (
    <div className="register">
      {loading || loadingInfo ? (
        <LoadingBox />
      ) : error || errorInfo ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <form onSubmit={submitHandler} className="modalOverideForm">
          {renderFieldGroup('Thông tin cá nhân', InputFields, false)}
          {renderFieldGroup('Thông tin gia đình', filtersFamily, true)}
          {renderFieldGroup('Thông tin bổ sung', filtersRegister, true)}
          <div
            className={`d-flex ${
              isUserInfo ? 'justify-content-end' : 'justify-content-center'
            } align-items-center `}
          >
            {isUserInfo && <button className=" btn-register-close">Hủy</button>}
            <button
              type="submit"
              className={isUserInfo ? 'btn-edit' : ' btn-register mb-3'}
            >
              {isUserInfo ? 'Cập nhật ' : 'Đăng ký '}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Register;
